<template>
    <div class="max-w-2xl mx-auto p-4">
        <h1 class="text-2xl font-semibold text-theme-base mb-2">
            Datos del cliente
        </h1>
        <p class="text-sm text-theme-muted mb-6">
            Elige qué datos le pides a tu cliente al hacer un pedido. Nombre,
            apellido y celular se piden siempre.
        </p>

        <div class="grid grid-cols-1 gap-8">
            <section v-for="item in items" :key="item.key">
                <h2 class="text-lg font-medium text-theme-base">
                    {{ item.name }}
                </h2>
                <p class="text-sm text-theme-muted mt-1">
                    {{ item.description }}
                </p>
                <div class="flex flex-wrap gap-6 mt-3">
                    <custom-radio
                        v-for="mode in modes"
                        :key="mode"
                        v-model="fields[item.key]"
                        :val="mode"
                        :disabled="!canUpdate"
                    >
                        {{ modeLabels[mode] }}
                    </custom-radio>
                </div>
            </section>
        </div>

        <div v-if="canUpdate" class="flex justify-end mt-8">
            <app-button :loading="isLoading" @click="save">
                Actualizar
            </app-button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import {
    defaultOrderCustomerFields,
    mapOrderCustomerFieldsFromApi,
    mapOrderCustomerFieldsToApi,
    orderCustomerFieldModeLabels,
    orderCustomerFieldModesOrder,
    orderCustomerFieldsItems
} from "@/common/fields/order-customer-fields";

import CustomRadio from "@/components/utils/CustomRadio.vue";

export default {
    name: "OrderCustomerFieldsSettingsPage",
    components: { CustomRadio },
    layout: "app",
    data: () => ({
        isLoading: false,
        fields: defaultOrderCustomerFields()
    }),
    computed: {
        ...mapGetters("control", ["backgroundColor"]),
        items() {
            return orderCustomerFieldsItems;
        },
        modes() {
            return orderCustomerFieldModesOrder;
        },
        modeLabels() {
            return orderCustomerFieldModeLabels;
        },
        canUpdate() {
            return this.$ability.hasPermission("tenant:UpdateOrdersSettings");
        }
    },
    async mounted() {
        const verifyPagePermission =
            this.$ability.verifyPagePermission.bind(this);
        if (
            !(await verifyPagePermission(
                "tenant:GetOrdersSettings",
                "/app/settings"
            ))
        )
            return;
        await this.loadSettings();
    },
    methods: {
        ...mapActions("tenants", [
            "getTenantOrdersSettings",
            "updateTenantOrdersSettings"
        ]),
        async loadSettings() {
            try {
                const data = await this.$loading.wrap(() =>
                    this.getTenantOrdersSettings()
                );
                this.fields = mapOrderCustomerFieldsFromApi(data);
            } catch (error) {
                this.$sound.play("error");
                await this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async save() {
            this.isLoading = true;
            try {
                await this.$loading.wrap(() =>
                    this.updateTenantOrdersSettings(
                        mapOrderCustomerFieldsToApi(this.fields)
                    )
                );
                this.isLoading = false;
                this.$sound.play();
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Actualización exitosa",
                    icon: "success",
                    showCloseButton: true,
                    timer: 3000
                });
            } catch (error) {
                this.isLoading = false;
                this.$sound.play("error");
                await this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        }
    }
};
</script>
